// ---- FORM ----

export function connectedText() {
	return "you are not connected";
}

export function chainText() {
	return "you are not on the correct chain";
}

export function noValue() {
	return "please type in a value";
}

export function minBalanceText(currentValue, minValue) {
	return "your balance needs to be at least " + minValue + ", current balance: " + currentValue;
}

export function minEqualBalanceText(currentValue, minEqualValue) {
	return "your balance needs to be bigger than " + minEqualValue + ", current balance: " + currentValue;
}

// ---- FORM - NUMBER INPUT ----

export function zeroText() {
	return "zero is not allowed as a value";
}

export function minText(min) {
	return "please type in a number bigger than or equal to " + min;
}

export function maxText(max) {
	return "please type in a number smaller than or equal to " + max;
}

// ---- METAMASK / WALLET CONNECT ----

export function onlyMetaMask() {
	return "only available for metamask";
}

export function noMetaMask() {
	return "metamask is not installed on your device";
}

export function onlyDisconnect() {
	return "you can only disconnect metamask yourself via restarting the browser";
}

export function requestedChain() {
	return "the requested chain is not supported";
}

export function chainDoesNotExist() {
	return "this chain does not exist on your wallet provider";
}

// ---- STAKING ----

export function neitherToken(tokenASymbol, tokenBSymbol) {
	return "you have no " + tokenASymbol + " or " + tokenBSymbol;
}

export function norClaimableStaked() {
	return "you can only redeem if you have any claimable or staked amount";
}

// ---- NFT ----

export function mintNftText(myInkBalance, pixelAmount) {
	return "you can only draw " + myInkBalance + " pixels, current: " + pixelAmount;
}

export function collectionAlreadyExists() {
	return "this collection already exists";
}

export function nftAlreadyExists() {
	return "this nft already exists";
}

export function royaltyBoth() {
	return "either both or none of the royalty inputs needs to be filled in";
}

export function badWords() {
	return "this text contains bad words";
}

export function startEndPrice() {
	return "your start price cannot be higher than your end price";
}

export function noBurnAmount() {
	return "your burn amount is still 0, please wait till it increases";
}

export function noRoyalty() {
	return "your royalty amount is still 0, please wait till it increases";
}

export function noMyInkForMigrate() {
	return "you need to have at least half of the pixel amount in MyINK tokens";
}

// ---- NFT - MARKETPLACE ----

export function offerClosed() {
	return "the offer is already closed";
}

export function offerNotClosed() {
	return "the offer is not closed yet";
}

export function creator() {
	return "the creator of an offer cannot bid on the offer";
}

export function highestBidder() {
	return "the highest bidder of an offer cannot bid on the offer";
}

export function notCreatorBidder() {
	return "you are neither the offer creator nor the winning bidder";
}
